/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { axiosInstance } from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { imgUrl } from "../utils/imgUrl";

const HomeBanner = ({ categories, setFilterCategory }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();
  const [paramSearch, setParamSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [discount, setDiscount] = useState([]);
  const getDiscount = async () => {
    setLoader(true);
    try {
      await axiosInstance.get("user/banner").then((response) => {
        if (response?.data?.status === true) {
          setLoader(false);

          setDiscount(response?.data?.banner);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    getDiscount();
  }, []);
  const searchByCategory = async () => {
    try {
      await axiosInstance
        .get("user/product", {
          params: { category_id: selectedCategory, search: paramSearch },
        })
        .then((response) => {
          if (response.data.status === true) {
            setFilterCategory(response?.data);
          }
        });
    } catch (error) {}
  };
  return (
    <>
      <section className="banner">
        <div className="banner_overlay">
          <span className="banner_shape_1">
            <img
              src="images/tree_5.png"
              alt="shape"
              className="img-fluid w-100"
            />
          </span>
          <span className="banner_shape_2">
            <img
              src="images/tree_3.png"
              alt="shape"
              className="img-fluid w-100"
            />
          </span>
          <span className="banner_shape_3">
            <img
              src="images/tree_4.png"
              alt="shape"
              className="img-fluid w-100"
            />
          </span>
          <span className="banner_shape_4">
            <img
              src="images/tree_6.png"
              alt="shape"
              className="img-fluid w-100"
            />
          </span>
          <span className="banner_shape_5">
            <img
              src="images/tree_7.png"
              alt="shape"
              className="img-fluid w-100"
            />
          </span>
          <span className="banner_shape_6">
            <img
              src="images/tree_2.png"
              alt="shape"
              className="img-fluid w-100"
            />
          </span>
          <div className="col-12">
            <div
              className="banner_slider"
              style={{
                background: "url(images/home_banner.jpg)",
              }}
            >
              <div className="banner_slider_overlay">
                <div className=" container">
                  <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-6 col-md-10 col-lg-6">
                      <div
                        className="banner_text wow fadeInLeft"
                        data-wow-duration="1s"
                      >
                        <h3>Ignite Your Taste Buds</h3>
                        <h1>Delicious BBQ With Tantalizing Flavor</h1>
                        <p className="font-20">
                          Thanks For Choosing Afrikan BBQ. We look forward to
                          serving you and sharing the rich flavor of Africa here
                          in Spokane, WA.
                        </p>
                        <form className="d-flex align-items-center gap-3 bg-transparent p-0">
                          <select
                            name=""
                            className="custom-style font-20"
                            onChange={(e) =>
                              setSelectedCategory(e.target.value)
                            }
                          >
                            {categories.map((e, i) => (
                              <option value={e?.id}>{e?.name}</option>
                            ))}
                          </select>
                          <div
                            style={{ width: "70%" }}
                            className="position-relative"
                          >
                            <input
                              onChange={(e) => setParamSearch(e.target.value)}
                              type="text"
                              className="w-100"
                              placeholder="Search . . ."
                            />
                            <div>
                              <IoIosSearch
                                size={30}
                                style={{
                                  position: "absolute",
                                  top: "21%",
                                  right: "20px",
                                }}
                              />
                            </div>
                          </div>
                        </form>
                        <button
                          onClick={searchByCategory}
                          type="submit"
                          style={{ width: "fit-content" }}
                          className="common_btn  ms-auto mt-2 font-20"
                        >
                          search
                        </button>
                      </div>
                    </div>
                    <div className="col-xxl-5 col-xl-6 col-sm-10 col-md-9 col-lg-6">
                      <div
                        className="banner_img wow fadeInRight"
                        data-wow-duration="1s"
                      >
                        <div
                          className="img"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/discount");
                          }}
                        >
                          <img
                            src={imgUrl + discount?.image}
                            alt="food item"
                            className="img-fluid w-100"
                          />
                          <span>{discount?.discount}% off</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;
